import { useFormikContext, withFormik } from "formik";
import * as yup from "yup";
import { OrButton } from "../shared_modules/ui/components/atoms/or-button/or-button";
import { MdiEye, MdiEyeOff } from "../shared_modules/ui/components/atoms/or-icon";
import { OrInput } from "../shared_modules/ui/components/atoms/or-input/or-input";

export default function WorkerPasswordValidator({ done }) {
  const FormView = (props) => {
    const { setFieldValue } = useFormikContext();
    const { values, touched, errors, isSubmitting, handleChange, handleSubmit } = props;

    return (
      <form className="or-auth-form" onSubmit={handleSubmit}>
        <div className="or-auth-form__group">
          <OrInput
            id="password"
            inputType={values.showPassword ? "text" : "password"}
            label="Contraseña *"
            name="password"
            onChange={handleChange}
            placeholder="********************"
            value={values.password}
            hasError={touched.password && Boolean(errors.password)}
            errorText={touched.password ? errors.password : ""}
            rightSlot={
              <button
                className="or-auth-password-toggle"
                id="passwordicon"
                type="button"
                aria-label="toggle password visibility"
                onClick={() => setFieldValue("showPassword", !values.showPassword)}
              >
                {values.showPassword ? <MdiEyeOff /> : <MdiEye />}
              </button>
            }
          />
        </div>

        <div className="or-auth-form__group">
          <OrInput
            id="confirmpassword"
            inputType={values.showRepeatedPassword ? "text" : "password"}
            label="Repite la contraseña *"
            name="confirmpassword"
            onChange={handleChange}
            placeholder="********************"
            value={values.confirmpassword}
            hasError={touched.confirmpassword && Boolean(errors.confirmpassword)}
            errorText={touched.confirmpassword ? errors.confirmpassword : ""}
            rightSlot={
              <button
                className="or-auth-password-toggle"
                id="confirmpasswordicon"
                type="button"
                aria-label="toggle password visibility"
                onClick={() => setFieldValue("showRepeatedPassword", !values.showRepeatedPassword)}
              >
                {values.showRepeatedPassword ? <MdiEyeOff /> : <MdiEye />}
              </button>
            }
          />
        </div>

        <div className="or-auth-form__group">
          <OrButton type="submit" fullWidth isLoading={isSubmitting} size="lg" variant="primary">
            ACEPTAR INVITACIÓN
          </OrButton>
        </div>
      </form>
    );
  };

  const validationsForm = {
    password: yup
      .string()
      .min(8, "La contraseña es demasiado corta. debe tener un mínimo de 8 caracteres.")
      .required("La password es requerida"),
    confirmpassword: yup
      .string()
      .oneOf([yup.ref("password"), null], "Las contraseñas deben coincidir")
      .required("La password es requerida"),
  };

  const Form = withFormik({
    mapPropsToValues: ({ password, confirmpassword }) => {
      return {
        password: password || "",
        confirmpassword: confirmpassword || "",
      };
    },

    enableReinitialize: true,
    validationSchema: yup.object().shape(validationsForm),
    handleSubmit: async (values) => {
      done(values);
    },
  })(FormView);

  return <Form />;
}
